import { render, staticRenderFns } from "./AsignmentSuperviceForeman.vue?vue&type=template&id=36f308b3&scope=props"
import script from "./AsignmentSuperviceForeman.vue?vue&type=script&lang=js"
export * from "./AsignmentSuperviceForeman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports